export default __webpack_public_path__ + "static/media/Sports-Social-Media.370b0510.png";